import { store } from '@/store';
export const searchBarModules = [
    'md-search-bar',
    'md-search',
    'md-snapshot-search',
    'md-search-grid-list',
    'md-search-big-map'
];
export function findSearchBar(type, mark, modules, id) {
    switch (type) {
        case 'direction':
            // mark 大于 0 ,当前模块往上找
            // mark 小于0 ,当前模块往下找
            return findSearchBarByDirection(mark, modules, id);
        default:
            return findFirstStore();
    }
}
function findFirstStore() {
    const storeName =
        window.siteAppVm &&
        window.siteAppVm.moduleData
            .filter((m) => searchBarModules.includes(m.name) && m.data)
            .map((m) => m.data.$storeName)[0];

    if (!storeName) {
        return null;
    } else {
        const module = store._modulesNamespaceMap[`${storeName}/`];
        if (!module) {
            return null;
        }
        return module.context;
    }
}
function findSearchBarByDirection(mark, modules, id) {
    const index = modules.findIndex((m) => m.id === id);
    let start = mark > 0 ? 0 : index;
    let end = mark > 0 ? index : modules.length;
    const arr = modules
        .slice(start, end)
        .filter((m) => searchBarModules.includes(m.name));
    const searchModule =
        mark > 0 ? arr[arr.length - mark] : arr[Math.abs(mark) - 1];
    if (searchModule) {
        return { ...searchModule };
    } else {
        return false;
    }
    // if (searchModule) {
    //     this.searchModule = { ...searchModule };
    //     return true;
    // } else {
    //     return false;
    // }
}
